import socketio from 'socket.io-client';

export const socket = socketio(process.env.REACT_APP_SOCKET_URL);

// Add connection debugging
socket.on('connect', () => {
  console.log('Socket connected with ID:', socket.id);
});

socket.on('disconnect', () => {
  console.log('Socket disconnected');
});

socket.on('connect_error', (error) => {
  console.error('Socket connection error:', error);
});